import {
  GET_REPORTS_FAILED,
  GET_REPORTS_REQUESTED,
  GET_REPORTS_SUCCEEDED,
  SET_SELECTED_REPORT_ID
} from 'store/Reports/constants'
import api from 'utils/api'

export const fetchReportsRequested = () => ({
  type: GET_REPORTS_REQUESTED
})
export const fetchReportsSucceeded = data => ({
  type: GET_REPORTS_SUCCEEDED,
  payload: data
})
export const fetchReportsFailed = data => ({
  type: GET_REPORTS_FAILED,
  payload: data
})

export const setSelectedReportId = reportId => ({
  type: SET_SELECTED_REPORT_ID,
  payload: reportId
})

export const fetchReports = () => dispatch => {
  dispatch(fetchReportsRequested())

  return api
    .fetchReportUrl()
    .then(({ data }) => dispatch(fetchReportsSucceeded(data)))
    .catch(err => dispatch(fetchReportsFailed(err)))
}
